function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Icons/Delete");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "All-Screens",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Profile---1820x1024",
  transform: "translate(-347.000000, -168.000000)",
  fill: "#FFFFFF"
}, React.createElement("g", {
  id: "Me",
  transform: "translate(272.000000, 100.000000)"
}, React.createElement("g", {
  id: "photo-profile",
  transform: "translate(40.000000, 34.000000)"
}, React.createElement("g", {
  id: "Icons/Delete",
  transform: "translate(32.000000, 32.000000)"
}, React.createElement("g", {
  id: "noun_Delete_756937",
  transform: "translate(3.000000, 2.000000)"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("g", {
  id: "Shape"
}, React.createElement("path", {
  d: "M0.714285714,11.6678217 C0.714285714,11.8512787 0.874096143,12 1.07167664,12 L8.92832336,12 C9.12570493,12 9.28571429,11.8533956 9.28571429,11.6678217 L9.28571429,2.99884493 C9.28571429,2.81538793 9.12590386,2.66666667 8.92832336,2.66666667 L1.07167664,2.66666667 C0.874295071,2.66666667 0.714285714,2.81327103 0.714285714,2.99884493 L0.714285714,11.6678217 Z M10,1.00312297 C10,0.817303267 9.84361379,0.666666667 9.64181096,0.666666667 L7.58897632,0.666666667 C7.53983607,0.666666667 7.46930804,0.638020833 7.43910039,0.609827033 L7.03955589,0.236918833 C6.89936304,0.106072167 6.622977,0 6.43021514,0 L3.56978486,0 C3.37344811,0 3.10267857,0.104166667 2.96044411,0.236918833 L2.56089961,0.609827033 C2.52726568,0.6412187 2.45660782,0.666666667 2.41102368,0.666666667 L0.358189036,0.666666667 C0.160366714,0.666666667 0,0.814451067 0,1.00312297 L0,1.6635437 C0,1.8493634 0.157076107,2 0.355905286,2 L9.64409471,2 C9.84065579,2 10,1.8522156 10,1.6635437 L10,1.00312297 Z"
})))))))));

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "10px",
    height: "12px",
    viewBox: "0 0 10 12",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.544f4c0d.svg";
export { ForwardRef as ReactComponent };